document.addEventListener("DOMContentLoaded", function () {
    const videoSections = document.querySelectorAll(".instagram-video-part");

    videoSections.forEach((section) => {
      const video = section.querySelector("video");
      const playBtn = section.querySelector(".instagram-video-play");

      // 🔹 Video click toggles play/pause
      video.addEventListener("click", function () {
        if (video.paused) {
          // Pause all other videos
          document.querySelectorAll(".instagram-video-part video").forEach((v) => v.pause());
          document.querySelectorAll(".instagram-video-play").forEach((btn) => btn.classList.remove("active"));

          // Play this one
          video.play();
          playBtn.classList.add("active");
        } else {
          video.pause();
          playBtn.classList.remove("active");
        }
      });

      playBtn.addEventListener("click", function (e) {
        e.preventDefault();

        if (video.paused) {
          // Pause all other videos first
          document.querySelectorAll(".instagram-video-part video").forEach((v) => v.pause());
          document.querySelectorAll(".instagram-video-play").forEach((btn) => btn.classList.remove("active"));

          // Play this one
          video.play();
          playBtn.classList.add("active");
        } else {
          video.pause();
          playBtn.classList.remove("active");
        }
      });
    });

    new Swiper('.instagram-feed', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      loop: true,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      //freeMode: true,
      allowTouchMove: false,
      speed: 4000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
    });
});
  // const instaFeed = new Swiper('.instagram-feed', {
  //   slidesPerView: 'auto',
  //   spaceBetween: 20,
  //   loop: true,
  //   slidesOffsetBefore: 20,
  //   slidesOffsetAfter: 20,
  //   freeMode: true,
  //   allowTouchMove: false,
  //   speed: 7000, // speed of movement (higher = slower scroll)
  //   autoplay: {
  //     delay: 0, // no delay between transitions
  //     disableOnInteraction: false
  //   }
  // });
